import React from "react";
import { Edit as EditIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
import { t } from "i18next";
import { REOPEN_RESPONSE } from "../../Queries";
import { useErrorBoundary } from "../../Contexts/ErrorContext";
import { User, Response } from "../../types";

export interface Props {
  user: User;
  responses: Response[];
  responseAuthors: User[];
}

// FL-84: instructor-only button to reopen an individual student's response
// for further modification — revise a completed response, or grant access on
// a survey that has closed. Placed to the left of the RespondButton.
export const ReopenButton = ({ responses, responseAuthors, user }: Props) => {
  const { setError } = useErrorBoundary();

  const [reopenResponse, { loading }] = useMutation(REOPEN_RESPONSE, {
    refetchQueries: ["GetResponsesSummary"],
    onError: (error) => setError(t("errors.responses.reopen"), error),
  });

  const response = responses.find((r) => user.id === r.authorId);
  const disabled = !responseAuthors.includes(user) || !response || loading;

  function handleClick() {
    if (response) {
      reopenResponse({ variables: { responseId: response.id } });
    }
  }

  return (
    <Tooltip title={disabled ? "" : "Reopen response"}>
      <span>
        <IconButton
          edge="end"
          aria-label="reopen response"
          disabled={disabled}
          onClick={handleClick}
        >
          <EditIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};
